import isEmpty from 'lodash-es/isEmpty';
import { axios } from 'wisestep-api';

import publicAllowedUrlPaths from '../utils/publicAllowedUrlPaths';
import {
  getAuthToken,
  logout,
  getWorkspaceToken,
  setWorkspaceToken,
  setNavURL,
  navigateToOTp,
} from '../utils/token';

const Axios: any = axios;

export const authInterceptor = () => {
  Axios.interceptors.request.use(
    function (config: any) {
      const authCookie = getAuthToken();
      // if (isEmpty(config.headers)) {
      //   config.headers = {};
      //   config.headers['Content-Type'] = 'application/json';
      // }
      if (authCookie) {
        config.headers.Authorization = 'Bearer ' + authCookie;
      }
      if (config.url.indexOf('s3.amazonaws.com') > 0) {
        config['headers'] = {};
        config.params = {};
      } else if (!isEmpty(getWorkspaceToken())) {
        config.headers['x-workspace-token'] = getWorkspaceToken();
      }
      if (config.url.indexOf('s3.amazonaws.com') < 0) {
        config.params.cacheBuster = new Date().getTime();
      }
      config.withCredentials = true;
      return config;
    },
    function (error: any) {
      return Promise.reject(error);
    }
  );

  Axios.interceptors.response.use(
    function (response: any) {
      if (response && response.headers && !isEmpty(response.headers['x-workspace-token'])) {
        setWorkspaceToken(response.headers['x-workspace-token']);
      }
      return response;
    },
    function (error: any) {
      if (
        !publicAllowedUrlPaths.includes(window.location.pathname) &&
        !window.location.pathname.includes('/data-protection') &&
        !location.pathname.includes('/subscription') &&
        !location.pathname.includes('/unsubscribe') &&
        !location.pathname.includes('/subscribed')
      ) {
        if (error.response?.status === 403 || error.response?.status === 401) {
          setNavURL(window.location.pathname);
          logout();
        } else if (error.response?.status === 412) {
          navigateToOTp();
        }
      }
      return Promise.reject(error);
    }
  );
};
